import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import React from 'react';
import PropTypes from "prop-types";
import * as stylex from "@stylexjs/stylex";
import Icon from "noood/comp/ui/feather-icon/Icon";
export default function Tag(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({}, stylex.props(ui.base, props.monospace && ui.monospace), {
    style: _objectSpread({
      backgroundColor: props.color,
      color: props.textColor
    }, props.style)
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: "3px"
    }
  }, props.icon && /*#__PURE__*/React.createElement(Icon, {
    icon: props.icon
  }), /*#__PURE__*/React.createElement("div", null, props.value))));
}
Tag.propTypes = {
  color: PropTypes.string,
  value: PropTypes.string,
  textColor: PropTypes.string,
  style: PropTypes.object
};
Tag.defaultProps = {
  textColor: "#000",
  color: "var(--shade-dark)"
};

// @ts-ignore
_inject(".evxwrc4x{border-radius:var(--roundness)}", 2000);
_inject(".ev1987f1p{padding:2px 5px}", 1000);
_inject(".ev1ejc5qp{font-size:var(--text-size-XS)}", 3000);
_inject(".ev1rg5ohu{display:inline-block}", 3000);
_inject(".ev19ofvfr{font-family:mono}", 3000);
var ui = {
  base: {
    "Tag__ui.base": "Tag__ui.base",
    borderRadius: "evxwrc4x",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    padding: "ev1987f1p",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    fontSize: "ev1ejc5qp",
    display: "ev1rg5ohu",
    $$css: true
  },
  monospace: {
    "Tag__ui.monospace": "Tag__ui.monospace",
    fontFamily: "ev19ofvfr",
    $$css: true
  }
};